import { Krub } from 'next/font/google';
import { ReactNode } from 'react';
import classnames from 'classnames';

const krub = Krub({
  weight: ['400', '600'],
  style: ['normal'],
  subsets: ['latin'],
});

const className = classnames(krub.className, 'h-full', 'bg-background-color');

interface Props {
  children: ReactNode;
}

const Body = ({ children }: Props) => (
  <body className={className}>{children}</body>
);

export default Body;
